var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initMarqueeBar = /* @__PURE__ */ __name(($el, blockSize, duration) => {
  const handleMarqueeResize = /* @__PURE__ */ __name(() => {
    if ($el.children[0]?.children.length) {
      [...new Array(Math.ceil($el.clientWidth * 2 / $el.scrollWidth) - 1)].forEach((_, index) => {
        [...$el.children[0].children].forEach((child) => {
          const newChild = child.cloneNode(true);
          newChild.setAttribute("aria-hidden", "true");
          $el.children[0].appendChild(newChild);
        });
        [...$el.children[1].children].forEach((child) => {
          const newChild = child.cloneNode(true);
          $el.children[1].appendChild(newChild);
        });
      });
      $el.style.setProperty(
        "--animate-duration",
        `${Math.round($el.children[0].children.length / blockSize) * +duration}`
      );
    }
  }, "handleMarqueeResize");
  return {
    handleMarqueeResize
  };
}, "initMarqueeBar");
window._sections["initMarqueeBar"] = initMarqueeBar;
